import React from "react";
import { ScaleAnswerFormat } from "../../../../types/Survey";
import Scale from "../../Components/Scale/Scale";
import { SurveyQuestionProps } from "../../Components/SurveyQuestion/SurveyQuestion";
import SurveyFormItem from "../../Components/SurveyFormItem/SurveyFormItem";
import { QuestionResultModel } from "../../../../types/SurveyResult";

export default function (props: SurveyQuestionProps) {
    let scaleAnswerFormat = props.answerFormat as ScaleAnswerFormat;
    let currentResult = props.result as QuestionResultModel;

    return <SurveyFormItem
        bottomBorder={!!props.label}
        label={props.label}
        labelPosition="top"
        variant={props.variant}
        labelFor={props.inputIdForLabel}
        useFieldsetFormat={props.useFieldsetFormat}
        index={props.index}>
        <Scale
            inputIdForLabel={props.inputIdForLabel}
            variant={props.variant}
            topBorder={!!props.label && props.variant !== "cardBased" && props.variant !== "v2"}
            answerFormat={scaleAnswerFormat}
            value={currentResult.Answer || ""}
            onChange={(value) => props.onResultChange({ ...props.result, Answer: value } as QuestionResultModel)} />
    </SurveyFormItem>;
}